interface LogContext {
  userId?: number;
  sessionId?: string;
  featureFlags?: string[];
}

let context: LogContext = {};

export function setLogContext(newContext: Partial<LogContext>) {
  context = { ...context, ...newContext };
}

export function getLogData() {
  return context;
}
